import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import {
  useGetInspectionQuery,
  usePostCorrectionInspectionMutation,
} from "@/services/backend/inspections/service";
import ConfirmationDialog from "@/shared/components/domain/confirmation/confirmation-dialog";
import { Button } from "@/shared/components/ui/button";
import { useAuth } from "@/shared/lib/authorization/auth-context";
import { createEntityId } from "@/shared/nidavellir/types/entity-id";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface CreateCorrectionButtonProps {
  processId: string;
  reportId: string;
  disabled?: boolean;
}

export function CreateCorrectionButton({
  processId,
  reportId,
  disabled = false,
}: CreateCorrectionButtonProps) {
  const canAccess = useFeatureAuth("inspections.inspection.create");
  const { data: srcReport, isLoading: reportIsLoading } = useGetInspectionQuery(
    { id: reportId },
  );
  const [create, { isLoading, error }] = usePostCorrectionInspectionMutation();
  const { user } = useAuth();
  if (!user) {
    return null;
  }
  const onConfirm = () => {
    if (isLoading || !canAccess) {
      return;
    }

    create({
      id: createEntityId()!.toString(),
      processId,
      srcId: reportId,
      createdBy: user.id,
    });
  };

  if (reportIsLoading || !srcReport || !srcReport.inspection.immutable) {
    return null;
  }

  return (
    <>
      <ConfirmationDialog
        trigger={
          <Button disabled={disabled || !canAccess}>
            <p>Korrekturbericht erstellen</p>
          </Button>
        }
        title="Korrekturbericht erstellen"
        description="Hiermit wird ein neuer Korrekturbericht erstellt"
        onConfirm={onConfirm}
      />
      <RTKQueryErrorAlert error={error} />
    </>
  );
}
